import { Component, OnInit, DestroyRef, inject, ChangeDetectorRef, signal } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

// Services
import { MsalService } from "@azure/msal-angular";
import { StoreUserService } from '@app/core/state/store-user.service';
import { StoreAuthService } from '@app/core/auth/store-auth.service';
import { GetSectionService } from "../../../data/section/get-section.service";
import { UpdateSectionService } from "../../../data/section/update-section.service";
import { CreateSectionService } from "../../../data/section/create-section.service";
import { CreateBelongsService } from "../../../data/belongs/create-belongs.service";
import { DuplicateCheckService } from "../../../data/util/duplicate-check.service";
import { CreateMemberService } from "../../../data/member/create-member.service";
import { ListMembersService } from "../../../data/member/list-members.service";
import { CreateUserService } from "../../../data/user/create-user.service";
import { getRedirectUri } from '../../../utils';

import dayjs from "dayjs";
import { DatabaseCacheService } from "../../../data/cache/database-cache.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  StaffDetailMode,
  StaffDetailsComponent,
} from "../../admin-section/staff-details/staff-details.component";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { SECTION_DETAILS_I18N } from "./section-details.i18n";
import { firstValueFrom, forkJoin } from "rxjs";
import { Addresses, AddressesFormComponent, AddressesDefaultValue } from "../../shared/addresses-form/addresses-form.component";
import { ContactDetails, ContactDetailsFormComponent, ContactDetailsDefaultValue } from "../../shared/contact-details-form/contact-details-form.component";

@Component({
  selector: "app-section-details",
  templateUrl: "./section-details.component.html",
  styleUrls: ["./section-details.component.css"],
  imports: SHARED_IMPORTS,
})
export class SectionDetailsComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  // i18n定数（型安全・IDE補完対応）
  protected readonly i18n = SECTION_DETAILS_I18N;

  public sectionData: SectionData;

  public mode = Mode.disp;
  Mode = Mode;

  sectionFormGroup;
  private readonly defaultSectionData: SectionData = {
    sectionGroupId: "",
    id: null,

    sectionName: "",
    description: "",

    numOfLicence: "",

    zip: "",
    prefecture: "",
    city: "",
    town: "",
    line1: "",
    line2: "",

    phone: "",
    mobile: "",
    email: "",

    contractStatus: "",
    contractStartAt: "",
    contractEndAt: "",

    quotaModel: "SHARED",
    monthlyQuotaGB: 10,

    admins: null,
  };

  // 2026/7/15 あとでセクションのデータ構造をバックエンドに合わせるときに使用する
  // private readonly defaultSectionData: SectionData = {
  //   sectionGroupId: "",
  //   id: null,

  //   sectionName: "",
  //   description: "",

  //   numOfLicence: "",

  //   addresses: AddressesDefaultValue,
  //   contactDetails: ContactDetailsDefaultValue,
  //   contractInfo: contractInfoDefaultValue,
  //   sectionSettings: sectionSettingsDefaultValue,

  //   admins: null,
  // };


  contractStatus = [
    { value: "OPEN", viewValue: this.i18n.contractStatus.active },
    { value: "CLOSE", viewValue: this.i18n.contractStatus.inactive },
  ];

  sexOptions = [
    { value: "male",    viewValue: this.i18n.sexOptions.male },
    { value: "female",  viewValue: this.i18n.sexOptions.female  },
    { value: "other",   viewValue: this.i18n.sexOptions.other},
  ];

  // assignAdmin = [
  //   { value: 'assignLater', desc: this.i18n.assignAdmin.assignLater },
  //   { value: 'assignSelf', desc: this.i18n.assignAdmin.assignSelf },
  // ];

  userNameOrCode = [
    { value: 'name', desc: this.i18n.userNameOrCode.name },
    { value: 'code', desc: this.i18n.userNameOrCode.code },
  ];

  loginUserId: string;
  sectionId: any;
  sectionGroupId;
  admins;
  hasSectionManagement;
  isStaffOfSection = false;

  changesMade = false;
  isSending = signal(false);

  constructor(
    public dialogRef: MatDialogRef<SectionDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _matdialog: MatDialog,
    public storeUser: StoreUserService,
    public storeAuth: StoreAuthService,
    private msalService: MsalService,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public common: DatabaseCacheService,
    private getSectionService: GetSectionService,
    private updateSectionService: UpdateSectionService,
    private createSectionService: CreateSectionService,
    private createMemberService: CreateMemberService,
    private createUserService: CreateUserService,
    private duplicateCheckService: DuplicateCheckService,
    private router: Router,
    private createBelongsService: CreateBelongsService,
    private listMembersService: ListMembersService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.sectionData = this.data?.section ?? this.defaultSectionData;
    this.sectionId = this.sectionData?.id;
    this.sectionGroupId = this.sectionData?.sectionGroupId;
    this.hasSectionManagement =
      this.common.hasSectionManagement(this.sectionGroupId) ||
      this.common.hasAllSectionGroupManagement();
    let sectionWithRole = this.common
      .getSectionWithRole()
      .filter((s) => s.sectionId == this.sectionId);
    if (sectionWithRole.length > 0) {
      this.isStaffOfSection = true;
    }


    this.sectionFormGroup = new FormGroup({
      // 自分自身を管理者にするかどうか *************************
      makeMyselfAnAdmin: new FormControl(false),

      // 新規にスタッフを作成するときのデータ *******************
      createNewStaff: new FormControl(false),
      staffSignInName: new FormControl(""),
      staffEmailAddress: new FormControl("", [Validators.email]),
      staffFirstName: new FormControl(""),
      staffLastName: new FormControl(""),
      staffSex: new FormControl(""),
      staffUserManageRole: new FormControl(""),
      staffAccountManageRole: new FormControl(""),

      // 新規にユーザを作成する時のデータ *********************
      userNameOrCode: new FormControl(this.userNameOrCode[0].value),
      createNewUser: new FormControl(false),
      userFirstName: new FormControl(""),
      userLastName: new FormControl(""),
      userCode: new FormControl(""),
      userBirthDate: new FormControl(""),
      userSex : new FormControl(""),

      // セクションに関わるデータ ******************************
      sectionName: new FormControl("", [Validators.required]),
      description: new FormControl(""),

      id: new FormControl(""),
      numOfLicence: new FormControl("", [Validators.required]),

      zip: new FormControl("", [Validators.required]),
      prefecture: new FormControl("", [Validators.required]),
      city: new FormControl("", [Validators.required]),
      town: new FormControl("", [Validators.required]),
      line1: new FormControl("", [Validators.required]),
      line2: new FormControl(""),

      phone: new FormControl("", [Validators.required]),
      mobile: new FormControl(""),
      email: new FormControl("", [Validators.required, Validators.email]),

      contractStatus: new FormControl(""),
      contractStartAt: new FormControl(""),
      contractEndAt: new FormControl(""),

      quotaModel: new FormControl("SHARED"),
      monthlyQuotaGB: new FormControl("10"),
    },
    {
      validators: [userFormValidator, staffFormValidator]
    });

    this.sectionFormGroup.disable();

    this.sectionFormGroup.patchValue(this.sectionData);

    if (this.sectionData.id == null) {
      this.switchToEditMode();
    } else {
      this.listAdmins();
    }

    this.route.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {});
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit() {}

  listAdmins() {
    this.listMembersService
      .listMembers(this.sectionId
                    , "STAFF"
                    , true // activeUsersOnly
                    , true // includeClosedSections
                    )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          this.admins = res as any[];
        },
        (error) => {
        },
      );
  }

  switchToEditMode() {
    this.mode = Mode.input;

    // enableFields()を直接呼び出すと（おそらく並列に走っている）描画サイクルと衝突して画面の初期状態が崩れる。
    // これを避けるために描画が落ち着くまで待ってから enableFields()を呼び出す
    setTimeout(() => {
      this.enableFields();
    });
    
  }

  enableFields() {
    this.sectionFormGroup.get("makeMyselfAnAdmin").enable();

    this.sectionFormGroup.get("createNewStaff").enable();
    this.sectionFormGroup.get("staffSignInName").enable();
    this.sectionFormGroup.get("staffFirstName").enable();
    this.sectionFormGroup.get("staffLastName").enable();
    // this.sectionFormGroup.get("staffFirstNameEN").enable();
    // this.sectionFormGroup.get("staffLastNameEN").enable();
    this.sectionFormGroup.get("staffEmailAddress").enable();
    // this.sectionFormGroup.get("staffSendNotificationEmail").enable();
    this.sectionFormGroup.get("staffSex").enable();
    this.sectionFormGroup.get("staffUserManageRole").enable();
    this.sectionFormGroup.get("staffAccountManageRole").enable();

    this.sectionFormGroup.get("createNewUser").enable();
    this.sectionFormGroup.get("userNameOrCode").enable();
    this.sectionFormGroup.get("userLastName").enable();
    this.sectionFormGroup.get("userFirstName").enable();
    this.sectionFormGroup.get("userCode").enable();
    this.sectionFormGroup.get("userBirthDate").enable();
    this.sectionFormGroup.get("userSex").enable();

    this.sectionFormGroup.get("sectionName").enable();
    this.sectionFormGroup.get("description").enable();

    this.sectionFormGroup.get("zip").enable();
    this.sectionFormGroup.get("prefecture").enable();
    this.sectionFormGroup.get("city").enable();
    this.sectionFormGroup.get("town").enable();
    this.sectionFormGroup.get("line1").enable();
    this.sectionFormGroup.get("line2").enable();

    this.sectionFormGroup.get("phone").enable();
    this.sectionFormGroup.get("mobile").enable();
    this.sectionFormGroup.get("email").enable();

    // this.sectionFormGroup.get("contrractStartAt").enable(); // 変更できない
    // this.sectionFormGroup.get("contractEndAt").enable(); // ステータスを変更したらその日が契約終了
    this.sectionFormGroup.get("contractStatus").enable();

    if (this.common.hasQuotaManagement()) {
      this.sectionFormGroup.get("quotaModel").enable();
      this.sectionFormGroup.get("monthlyQuotaGB").enable();
    }

    this.sectionFormGroup.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.changesMade = true;
      });

  }

  openNewWindow(routerurl) {
    // Converts the route into a string that can be used
    // with the window.open() function
    const url = this.router.serializeUrl(
      this.router.createUrlTree([routerurl]),
    );
    window.open("#" + url, "_blank");
  }

  onEditClicked() {
    // 現在がディスプレイモードなら編集モードに切り替える
    if (this.mode == Mode.disp) {
      this.switchToEditMode();
      return;
    }
  }

  onUploadClicked() {
    //　各フィールドにValidationRuleを適用し確認
    this.sectionFormGroup.markAllAsTouched();
    this.sectionFormGroup.updateValueAndValidity();
    if (!this.sectionFormGroup.valid) {
      let snack = this.snackBar.open(
        this.i18n.validation.checkFields,
        this.i18n.button.close,
        {
          duration: 30000,
        },
      );
      return;
    }

    var postParams: Record<string, any> = {};

    postParams.makeMyselfAnAdmin = this.sectionFormGroup.value.makeMyselfAnAdmin;

    postParams.sectionGroupId = this.common.getSelectedSectionGroup().id;
    postParams.sectionName = this.sectionFormGroup.value.sectionName;
    postParams.description = this.sectionFormGroup.value.description;

    postParams.createNewStaff = this.sectionFormGroup.value.createNewStaff;
    postParams.staffSignInName = this.sectionFormGroup.value.staffSignInName;
    // パスワード生成はサーバ側で行うことにした
    //postParams.staffPassword = ['A', '1', 'a', '!'].concat(Array.from({length: 8}, () => 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+'[Math.floor(Math.random() * 74)])).sort(() => Math.random() - 0.5).join(''); // 12文字の中に大文字・数字・小文字・記号を分散して決め打ち配置し、残りをランダムにする
    postParams.staffFirstName = this.sectionFormGroup.value.staffFirstName;
    postParams.staffLastName = this.sectionFormGroup.value.staffLastName;
    // postParams.staffFirstNameEN = this.sectionFormGroup.value.staffFirstNameEN; // 20260523 英語名は任意入力から廃止することにした
    // postParams.staffLastNameEN = this.sectionFormGroup.value.staffLastNameEN; // 20260523 英語名は任意入力から廃止することにした
    postParams.staffEmailAddress = this.sectionFormGroup.value.staffEmailAddress;
    postParams.staffSex = this.sectionFormGroup.value.staffSex;
    postParams.staffUserManageRole = this.sectionFormGroup.value.staffUserManageRole;
    postParams.staffAccountManageRole = this.sectionFormGroup.value.staffAccountManageRole;

    postParams.createNewUser = this.sectionFormGroup.value.createNewUser;
    postParams.userNameOrCode = this.sectionFormGroup.value.userNameOrCode;
    postParams.userFirstName = this.sectionFormGroup.value.userFirstName;
    postParams.userLastName = this.sectionFormGroup.value.userLastName;
    postParams.userCode = this.sectionFormGroup.value.userCode;
    postParams.userSex = this.sectionFormGroup.value.userSex;
    postParams.userBirthDate = this.sectionFormGroup.value.userBirthDate;

    postParams.addresses = {};
    postParams.addresses.zip = this.sectionFormGroup.value.zip;
    postParams.addresses.prefecture = this.sectionFormGroup.value.prefecture;
    postParams.addresses.city = this.sectionFormGroup.value.city;
    postParams.addresses.town = this.sectionFormGroup.value.town;
    postParams.addresses.line1 = this.sectionFormGroup.value.line1;
    postParams.addresses.line2 = this.sectionFormGroup.value.line2;

    postParams.contactDetails = {};
    postParams.contactDetails.phone = this.sectionFormGroup.value.phone;
    postParams.contactDetails.mobile = this.sectionFormGroup.value.mobile;
    postParams.contactDetails.email = this.sectionFormGroup.value.email;

    postParams.contractInfo = {};
    postParams.contractInfo.contractStatus = this.sectionFormGroup.value.contractStatus;

    postParams.settings = {};
    postParams.settings.quotaModel =
      this.sectionFormGroup.getRawValue().quotaModel;
    postParams.settings.monthlyQuotaGB =
      this.sectionFormGroup.getRawValue().monthlyQuotaGB;

    console.log("creating section: postParams =", postParams);
    if (this.sectionId == null) {
      this.createSection(postParams);
    } else {
      this.updateSection(postParams);
    }
  }

  async createSection(postParams) {
    if (this.isSending()) {
      return;
    }
    this.isSending.set(true);

    try{
      // 重複チェック
      var staffSignInName = null;
      if (postParams.createNewStaff){
        staffSignInName = postParams.staffSignInName;
      }
      var sectionName = postParams.sectionName;

      let res = await firstValueFrom(this.duplicateCheckService.DuplicateCheck(staffSignInName, null, sectionName));
      let duplicates = (res as any[]);

      if (duplicates.some(d => 'SectionName' in d)){
        let snack = this.snackBar.open($localize`セクション名 "${sectionName}" はすでに使用されています`, $localize`閉じる`, { duration: 10000 });
        return true;
      }

      if (duplicates.some(d => 'SignInName' in d)){
        let snack = this.snackBar.open($localize`ユーザID "${staffSignInName}" はすでに使用されています`, $localize`閉じる`, { duration: 10000 });
        return true;
      }

      // セクション作成。ここでセクションIDが決まる
      const sectionRes = await firstValueFrom(
        this.createSectionService.createSection(this.common.getSelectedSectionGroup().id, postParams)
      );
      
      let sectionId = (sectionRes as any).sectionId;
      let user = this.msalService.instance.getActiveAccount();
      let loginUserId = user.idTokenClaims["sub"];

      // 管理者・STAFF・ユーザを割り当てる
      const parallelTasks = [];

      // // 管理者作成
      const willMakeMyselfAnAdmin = postParams.makeMyselfAnAdmin;
      if (willMakeMyselfAnAdmin) {
        var belongsCreatePostBody = {
          userId: loginUserId,
          sectionId: sectionId,
          role: adminStaffDefaultRole,
          privileges: adminStaffDefaultPrivileges,
          userType: "STAFF",
          jobTitleCode: "OTHER",
        };
        parallelTasks.push(
          this.createBelongsService.createBelongs(sectionId, belongsCreatePostBody)
        );
      }

      // // STAFF作成
      const willCreateStaff = postParams.createNewStaff;
      var memberCreatePostBody = {
        createUser: true,

        staffSignInName: postParams.staffSignInName,
        //staffPassword: postParams.staffPassword, // 20260523 パスワード生成はサーバ側で行うように変更
        passwordGenerateOnServer : true, // 20260523 パスワード生成はサーバ側で行うように変更
        staffFirstName: postParams.staffFirstName,
        staffLastName: postParams.staffLastName,
        staffEmailAddress: postParams.staffEmailAddress,
        staffBirthDate: postParams.staffBirthDate,
        staffSex: postParams.staffSex,

        sendNotificationEmail : true, // 利用開始の通知メールは必ず送ることにした
        notificationEmailSubject: "GOKURI: 利用開始の準備ができました",
        siteTopUrl : getRedirectUri(),

        sectionId: sectionId,
        role: demoStaffDefaultRole,
        privileges: demoStaffDefaultPrivileges,
        userType: "STAFF",
        jobTitleCode: "OTHER",
      };
      if (postParams.staffUserManageRole){
        memberCreatePostBody.role.push("USER_MANAGEMENT");
      }
      if (postParams.staffAccountManageRole){
        memberCreatePostBody.role.push("ACCOUNT_MANAGEMENT");
      }
      console.log("creating staff : memberCreatePostBody", memberCreatePostBody);
      if (willCreateStaff) parallelTasks.push(
        this.createMemberService.createMember(memberCreatePostBody)
      );

      // // ユーザ作成
      const willCreateUser = postParams.createNewUser;
      var userCreatePostBody = [
        {
          sectionId: sectionId,

          accountEnabled: "true",
          code: postParams.userNameOrCode == 'code'? postParams.userCode : null,
          firstName: postParams.userNameOrCode == 'name'? postParams.userFirstName : null,
          lastName: postParams.userNameOrCode == 'name'? postParams.userLastName : null,
          jobTitleCode: "NU", //一般ユーザーのコード
          birthDate:postParams.userBirthDate,
          sex: postParams.userSex,
        }
      ];
      if (willCreateUser) parallelTasks.push(
        this.createUserService.createUser(userCreatePostBody)
      );

      // forkJoin を await で待つことで、並列処理の完了をスッキリ待ち合わせ
      if (parallelTasks.length > 0) {
        await firstValueFrom(forkJoin(parallelTasks));
      }

      // ★ すべての並列処理が正常に完了したらここに入る
      if (willMakeMyselfAnAdmin) {
        this.sectionCreated(this.i18n.message.createWithAdminSuccess);
      } else {
        this.sectionCreated(this.i18n.message.createSuccess);
      }
    }
    catch(e){
      console.log("error creating section", e);
      return;
    }
    finally {
      this.isSending.set(false);
    }
  }

  sectionCreated(message) {
    let snack = this.snackBar.open(message, this.i18n.button.close, {
      duration: 30000,
    });
    snack
      .afterDismissed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.dialogRef.close({ needRefresh: true });
      });
  }

  inviteAdmin() {
    const dialogRef = this.dialog.open(StaffDetailsComponent, {
      width: "740px",
      disableClose: false,

      data: {
        title: this.i18n.dialog.confirmTitle,
        sectionId: this.sectionId,
        mode: StaffDetailMode.invite,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {});
  }

  updateSection(postParams) {
    try {
      this.updateSectionService
        .updateSection(this.sectionId, postParams)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((res) => {

          let snack = this.snackBar.open(
            this.i18n.message.updateSuccess,
            this.i18n.button.close,
            {
              duration: 30000,
            },
          );
          snack
            .afterDismissed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
              this.dialogRef.close({ needRefresh: true });
            });
        });
    } catch (e) {
      let snack = this.snackBar.open(
        this.i18n.message.updateError,
        this.i18n.button.close,
        {
          duration: 30000,
        },
      );
      snack
        .afterDismissed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.dialogRef.close();
        });
    }
  }
}

export enum Mode {
  disp,
  input,
}

export interface SectionData {
  sectionGroupId: string;
  id: string;

  sectionName: string;
  description: string;

  numOfLicence: string;

  zip: string;
  prefecture: string;
  city: string;
  town: string;
  line1: string;
  line2: string;

  phone: string;
  mobile: string;
  email: string;

  contractStatus: string;
  contractStartAt: string;
  contractEndAt: string;

  quotaModel: string;
  monthlyQuotaGB: number;

  admins: any[];
}

// 2026/7/15 あとでセクションのデータ構造をバックエンドに合わせるときに使用する
// export interface ContractInfo{
//   contractStatus: string;
//   contractStartAt: string;
//   contractEndAt: string;
// }

// const contractInfoDefaultValue = {
//     contractStatus: "",
//     contractStartAt: "",
//     contractEndAt: "",
// }

// export interface SectionSettings{
//   quotaModel: string;
//   monthlyQuotaGB: number;
// }

// const sectionSettingsDefaultValue = {
//     quotaModel: "SHARED",
//     monthlyQuotaGB: 10,
// }

// export interface SectionData {
//   sectionGroupId: string;
//   id: string;

//   sectionName: string;
//   description: string;

//   numOfLicence: string;

//   addresses: Addresses;
//   contactDetails: ContactDetails;
//   contractInfo: ContractInfo,
//   sectionSettings: SectionSettings;

//   admins: any[];
// }


export interface KeyValue {
  key: string;
  value: string;
}

export interface InUpdateMember {
  userType: string;
  role: string[];
  privileges: KeyValue[];
  contractStatus: string;
}

export const adminStaffDefaultRole = [
  "PRIMARY",
  "ACCOUNT_MANAGEMENT",
  "USER_MANAGEMENT",
  "MEASUREMENT",
  "REFER",
];

export const adminStaffDefaultPrivileges = [
  { key: "ACCOUNT", value: "CREATE" },
  { key: "ACCOUNT", value: "READ" },
  { key: "ACCOUNT", value: "UPDATE" },
  { key: "ACCOUNT", value: "DELETE" },
  { key: "USER", value: "CREATE" },
  { key: "USER", value: "READ" },
  { key: "USER", value: "UPDATE" },
  { key: "USER", value: "DELETE" },
  { key: "FOLLOW-UP", value: "CREATE" },
  { key: "FOLLOW-UP", value: "READ" },
  { key: "FOLLOW-UP", value: "UPDATE" },
  { key: "FOLLOW-UP", value: "DELETE" },
  { key: "RECORD", value: "CREATE" },
  { key: "RECORD", value: "READ" },
  { key: "RECORD", value: "UPDATE" },
  { key: "RECORD", value: "DELETE" },
];

export const demoStaffDefaultRole = [
  "MEASUREMENT",
  "REFER",
];

export const demoStaffDefaultPrivileges = [
  { key: "ACCOUNT", value: "READ" },
  { key: "ACCOUNT", value: "UPDATE" },
  { key: "ACCOUNT", value: "DELETE" },
  { key: "USER", value: "CREATE" },
  { key: "USER", value: "READ" },
  { key: "USER", value: "UPDATE" },
  { key: "USER", value: "DELETE" },
  { key: "FOLLOW-UP", value: "CREATE" },
  { key: "FOLLOW-UP", value: "READ" },
  { key: "FOLLOW-UP", value: "UPDATE" },
  { key: "FOLLOW-UP", value: "DELETE" },
  { key: "RECORD", value: "CREATE" },
  { key: "RECORD", value: "READ" },
  { key: "RECORD", value: "UPDATE" },
  { key: "RECORD", value: "DELETE" },
];

export const userFormValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const createNewUser = control.get('createNewUser')?.value;
  const userNameOrCode = control.get('userNameOrCode')?.value;
  
  const lastNameCtrl = control.get('userLastName');
  const firstNameCtrl = control.get('userFirstName');
  const codeCtrl = control.get('userCode');

  const errors: ValidationErrors = {};

  // 各コントロールの現在のカスタムエラーだけを一旦消去するためのヘルパー関数
  const clearCustomError = (ctrl: AbstractControl | null, errorKey: string) => {
    if (!ctrl) return;
    const currentErrors = ctrl.errors;
    if (currentErrors) {
      delete currentErrors[errorKey];
      // 他にエラーが残っていなければ null、残っていればそれを再設定
      ctrl.setErrors(Object.keys(currentErrors).length > 0 ? currentErrors : null);
    }
  };

  // 各フィールドの今回のエラーを一旦リセット
  clearCustomError(lastNameCtrl, 'userLastNameRequired');
  clearCustomError(firstNameCtrl, 'userFirstNameRequired');
  clearCustomError(codeCtrl, 'userCodeRequired');

  if (createNewUser === true) {
    // ルール2: name のときは lastName / firstName が必須
    if (userNameOrCode === 'name') {
      if (!lastNameCtrl?.value || lastNameCtrl.value.trim() === '') {
        errors['userLastNameRequired'] = true;
        lastNameCtrl?.setErrors({ ...lastNameCtrl.errors, userLastNameRequired: true });
      }
      if (!firstNameCtrl?.value || firstNameCtrl.value.trim() === '') {
        errors['userFirstNameRequired'] = true;
        firstNameCtrl?.setErrors({ ...firstNameCtrl.errors, userFirstNameRequired: true });
      }
    }

    // ルール3: code のときは userCode が必須
    if (userNameOrCode === 'code') {
      if (!codeCtrl?.value || codeCtrl.value.trim() === '') {
        errors['userCodeRequired'] = true;
        codeCtrl?.setErrors({ ...codeCtrl.errors, userCodeRequired: true });
      }
    }
  }

  return Object.keys(errors).length > 0 ? errors : null;
};

export const staffFormValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const createNewStaff = control.get('createNewStaff')?.value;
  
  const staffSignInNameCtrl = control.get('staffSignInName');
  const staffEmailAddressCtrl = control.get('staffEmailAddress');
  const staffFirstNameCtrl = control.get('staffFirstName');
  const staffLastNameCtrl = control.get('staffLastName');

  console.log("staffSignInNameCtrl", staffSignInNameCtrl);
  console.log("staffEmailAddressCtrl", staffEmailAddressCtrl);
  console.log("staffFirstNameCtrl", staffFirstNameCtrl);
  console.log("staffLastNameCtrl", staffLastNameCtrl);

  const errors: ValidationErrors = {};

  // 各コントロールの現在のカスタムエラーだけを一旦消去するためのヘルパー関数
  const clearCustomError = (ctrl: AbstractControl | null, errorKey: string) => {
    if (!ctrl) return;
    const currentErrors = ctrl.errors;
    if (currentErrors) {
      delete currentErrors[errorKey];
      // 他にエラーが残っていなければ null、残っていればそれを再設定
      ctrl.setErrors(Object.keys(currentErrors).length > 0 ? currentErrors : null);
    }
  };

  // 各フィールドの今回のエラーを一旦リセット
  clearCustomError(staffSignInNameCtrl, 'staffSignInNameRequired');
  clearCustomError(staffEmailAddressCtrl, 'staffEmailAddressRequired');
  clearCustomError(staffFirstNameCtrl, 'staffFirstNameRequired');
  clearCustomError(staffLastNameCtrl, 'staffLastNameRequired');

  if (createNewStaff === true) {
    if (!staffSignInNameCtrl?.value || staffSignInNameCtrl.value.trim() === '') {
      errors['staffSignInNameRequired'] = true;
      staffSignInNameCtrl?.setErrors({ ...staffSignInNameCtrl.errors, staffSignInNameRequired: true });
    }
    if (!staffEmailAddressCtrl?.value || staffEmailAddressCtrl.value.trim() === '') {
      errors['staffEmailAddressRequired'] = true;
      staffEmailAddressCtrl?.setErrors({ ...staffEmailAddressCtrl.errors, staffEmailAddressRequired: true });
    }

    if (!staffFirstNameCtrl?.value || staffFirstNameCtrl.value.trim() === '') {
      errors['staffFirstNameRequired'] = true;
      staffFirstNameCtrl?.setErrors({ ...staffFirstNameCtrl.errors, staffFirstNameRequired: true });
    }
    if (!staffLastNameCtrl?.value || staffLastNameCtrl.value.trim() === '') {
      errors['staffLastNameRequired'] = true;
      staffLastNameCtrl?.setErrors({ ...staffLastNameCtrl.errors, staffLastNameRequired: true });
    }
  }

  console.log("staffValidator", errors);
  return Object.keys(errors).length > 0 ? errors : null;
};